import React, { useState, useEffect } from "react";
import { BASE_API_URL, BASE_IMAGE_API_URL } from "../services/baseServices";
import Swal from 'sweetalert2';
import 'react-tooltip/dist/react-tooltip.css';
import axios from "axios";
import { Select, Popover } from 'antd';
import { Tooltip } from 'react-tooltip';
import MainLayout from "../layouts/MainLayout";
// import AddProduct from "./Add";
// import ViewProduct from "./View";
// import EditProduct from "./Edit";
import '../assets/styles/loader.css';
import '../assets/styles/pagination.css';
import ViewProduct from "../components/products/view";
import AddProduct from "../components/products/add";
import EditProduct from "../components/products/edit";
import { GET_DDL_ITEMS } from "../services/commonServices";
import { useNavigate } from "react-router-dom";
import { fetchOrganizations } from "../services/organizationServices";

export default function ProductsList () {
    
    const { Option } = Select;
    const [sessionUserData, setSessionUserData] = useState([]);
    const [categoriesData, setCategoriesData] = useState([]);
    const [productsData, setProductsData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [editItem, setEditItem] = useState('');
    const [viewItem, setViewItem] = useState(false);
    const [selectedOrgId, setSelectedOrgId] = useState(null);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [organizationsData, setOrganizationsData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setSessionUserData(userData);
        } else {
            navigate("/");
        }
    }, [navigate]);

    
    const fetchDDLItems = async (type) => {
        try {
            const response = await axios.get(`${BASE_API_URL}${GET_DDL_ITEMS}?OrgId=${sessionUserData?.OrgId}&UserId=${sessionUserData?.Id}`);
            const allItems = response.data.ResultData;
            
            const categoriesResponse = allItems.filter(item => item.DDLName === "Categories");
            setCategoriesData(categoriesResponse);
        } catch (error) {
            console.error(`Error fetching ${type}:`, error);
            return null;
        }
    };
    
    useEffect(() => {
        if (sessionUserData?.OrgId) {
            fetchDDLItems();
        }
    }, [sessionUserData]);

    const getOrganizations = async () => {
        try {
            const data = await fetchOrganizations();
            setOrganizationsData(data);
        } catch (error) {
            console.error('Failed to load organizations:', error);
        } finally {
            console.log('Organization fetch completed');
        }
    };

    useEffect(() => {
        getOrganizations();
    }, []);

    const handleFilter = async () => {
        if (!selectedOrgId || !selectedCategoryId) {
          Swal.fire("Missing Filters", "Please select both Organization and Category", "warning");
          return;
        }
      
        setDataLoading(true);
      
        const url = `${BASE_API_URL}ADMINRoutes/GetProducts?OrgId=${selectedOrgId}&CategoryId=${selectedCategoryId}`;
      
        try {
          const response = await fetch(url);
      
            if (response.ok) {
                const data = await response.json();
                setProductsData(data.ResultData);
                } else {
                    setProductsData([]);
                    Swal.fire("Error", "Failed to fetch products.", "error");
                }
            } catch (error) {
                console.error("Filter error:", error);
                setProductsData([]);
                Swal.fire("Error", "An unexpected error occurred.", "error");
            } finally {
                setDataLoading(false);
            }
    };

    const filteredData = (Array.isArray(productsData) ? productsData : []).filter((item) => {
        const disValue = item?.DisplayValue?.toLowerCase() || '';
        const query = searchQuery.toLowerCase();
        return disValue.includes(query);
      });

    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 5;
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

    const getPaginationNumbers = () => {
        const visiblePages = [];
        if (totalPages <= 6) {
            for (let i = 1; i <= totalPages; i++) visiblePages.push(i);
        } else {
            if (currentPage <= 3) {
                visiblePages.push(1, 2, 3, "...", totalPages - 2, totalPages - 1, totalPages);
            }
            else if (currentPage > 3 && currentPage < totalPages - 2) {
                visiblePages.push(1, 2, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages - 1, totalPages);
            }
            else {
                visiblePages.push(1, 2, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
            }
        }
        return visiblePages;
    };

    const handlePageClick = (page) => {
        if (page !== "...") setCurrentPage(page);
    };

    const handlePrevious = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleEditClick = (item) => {
        setEditItem(item);
    };

    const handleViewClick = (item) => {
        setViewItem(item);
    };

    const imageStyle = {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        objectFit: 'cover',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
        cursor: 'pointer',
        border: '2px solid #e0f2fe',
        backgroundColor: '#fff'
    };



    return (
        <MainLayout>
            <div className="content">
                <div className="page-header">
                    <div className="add-item d-flex">
                        <div className="page-title">
                            <h4 className="fw-bold">Products</h4>
                            <h6>Manage your products</h6>
                        </div>
                    </div>
                    <ul className="table-top-head">
                        {/* <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="assets/img/icons/pdf.svg" alt="img"/></a>
                        </li>
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="assets/img/icons/excel.svg" alt="img"/></a>
                        </li> */}
                        <li>
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i className="ti ti-refresh"></i></a>
                        </li>
                        
                    </ul>
                    <div className="page-btn">
                        <a href="#" className="btn btn-primary"  
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightAdd"
                            aria-controls="offcanvasRightAdd">
                                <i className="ti ti-circle-plus me-1"></i>New Content
                        </a>
                    </div>
                </div>
                
                <div className="card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <div className="search-set">
                            <div className="search-input">
                                <span className="btn-searchset"><i className="ti ti-search fs-14 feather-search"></i></span>
                                <input type="search" className="form-cotrol" placeholder="Search"/>
                            </div>
                        </div>
                        <div className="table-dropdown my-xl-auto right-content">
                        <div
                            className="d-flex flex-column flex-lg-row justify-content-lg-end justify-content-between align-items-end"
                            data-kt-customer-table-toolbar="base"
                        >
                            <div className={`d-flex flex-column me-3 mb-3 mb-md-0`}>
                                <label className="form-label">Organization</label>
                                <Select
                                    placeholder="Choose Organization"
                                    showSearch
                                    allowClear
                                    style={{ width: 250 }}
                                    optionFilterProp="children"
                                    onChange={(value) => setSelectedOrgId(value)}
                                    filterOption={(input, option) =>
                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    >
                                    {organizationsData && organizationsData?.map(org => (
                                        <Option key={org.OrgId} value={org.OrgId}>
                                            {org.OrgName}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                            <div className="d-flex flex-column me-3 mb-3 mb-md-0">
                                <label className="form-label">Category</label>
                                <Select
                                    showSearch
                                    allowClear
                                    placeholder="Choose Category"
                                    optionFilterProp="children"
                                    style={{ width: 250 }}
                                    onChange={(value) => setSelectedCategoryId(value)}
                                    filterOption={(input, option) =>
                                        (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {categoriesData && categoriesData?.map((item) => (
                                        <Option key={item.ItemId} value={item.ItemId}>
                                            {item.ItemValue}
                                        </Option>
                                    ))}
                                </Select>
                            </div>

                            <button
                                className="btn btn-info"
                                onClick={handleFilter}
                            >
                                <i className="fa-solid fa-filter"></i>Submit
                            </button>
                        </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table">
                                <thead className="thead-light">
                                    <tr>
                                        <th className="no-sort">#</th>
                                        <th>Name</th>
                                        <th className="">Brand</th>
                                        <th className="">Category</th>
                                        <th className="text-center">Description</th>
                                        <th>Status</th>
                                        <th className="no-sort">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="fw-semibold text-gray-600">
                                    {dataLoading ? (
                                        <tr>
                                            <td colSpan="12" className="text-center">
                                                <div className="container"></div>
                                            </td>
                                        </tr>
                                    ) : currentRecords && currentRecords.length > 0 ? (
                                        currentRecords.map((item, index) => (
                                            <tr>
                                                <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                                                <td>
                                                    <div className="d-flex align-items-center gap-3">
                                                        <img
                                                            src={`${BASE_IMAGE_API_URL}${item.ImageUrl}`}
                                                            alt="Item"
                                                            className="rounded-circle shadow"
                                                            style={imageStyle}
                                                            data-bs-toggle="modal"
                                                            data-bs-target={`#imageModal-${item.Id}`}
                                                        />

                                                        <div className="d-flex flex-column">
                                                            <span className="fw-bold text-dark">{item.ProductName}</span>
                                                            <span className="text-muted small">Code: {item.ProductCode}</span>
                                                        </div>
                                                    </div>
                                                </td>

                                                <td>
                                                    <a className="text-gray-800 text-hover-primary mb-1">{item.Brand}</a>
                                                </td>
                                                <td>
                                                    <a className="text-gray-800 text-hover-primary mb-1">{item.CategoryId}</a>
                                                </td>
                                                <td className="text-center">
                                                    <i
                                                        className="fa-solid fa-message fa-lg"
                                                        data-tooltip-id={`desc-tooltip-${item.Id}`}
                                                        data-tooltip-html={item.Description}
                                                        style={{ cursor: 'pointer' }}
                                                    ></i>

                                                    <Tooltip id={`desc-tooltip-${item.Id}`} place="top"
                                                        style={{
                                                            maxWidth: '200px',
                                                            whiteSpace: 'normal',
                                                            textAlign: 'left',
                                                            padding: '8px',
                                                            borderRadius: '6px',
                                                            backgroundColor: '#e0f2fe',
                                                            color: '#0c4a6e',
                                                            fontSize: '13px',
                                                            border: '1px solid #bae6fd'
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <div className={"badge badge-light-success"}>
                                                        Active
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <Popover 
                                                        placement="bottom" 
                                                        content={
                                                            <div style={{ width: '7rem' }}>
                                                                <p
                                                                    className={`text-hover-warning cursor-pointer`}
                                                                    data-bs-toggle="offcanvas"
                                                                    data-bs-target="#offcanvasRightView"
                                                                    aria-controls="offcanvasRightView"
                                                                    onClick={() => handleViewClick(item)}
                                                                >
                                                                    <i className="fa-regular fa-eye me-2 text-info"></i>
                                                                    View
                                                                </p>
                                                                <p
                                                                    className={`text-hover-warning cursor-pointer`}
                                                                    data-bs-toggle="offcanvas"
                                                                    data-bs-target="#offcanvasRightEdit"
                                                                    aria-controls="offcanvasRightEdit"
                                                                    onClick={() => handleEditClick(item)}
                                                                >
                                                                    <i className="fa-regular fa-pen-to-square me-2 text-warning"></i>
                                                                    Edit 
                                                                </p>
                                                            </div>
                                                        }
                                                        trigger="hover"
                                                    >
                                                        <button 
                                                            className="btn"
                                                        >
                                                            <i className="fa-solid fa-ellipsis-vertical"></i>
                                                        </button>
                                                    </Popover>
                                                </td>
                                            </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <p>No Data Available</p>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                            </table>
                            <div className="dt-paging paging_simple_numbers">
                                <nav aria-label="pagination">
                                    <ul className="pagination">
                                        <li
                                            className={`dt-paging-button page-item ${currentPage === 1 ? "disabled" : ""}`}
                                        >
                                            <button
                                                className="page-link previous"
                                                role="link"
                                                type="button"
                                                aria-controls="kt_customers_table"
                                                aria-disabled={currentPage === 1}
                                                aria-label="Previous"
                                                onClick={handlePrevious}
                                            >
                                                <i className="previous"></i>
                                            </button>
                                        </li>

                                        {/* Page Numbers */}
                                        {getPaginationNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`dt-paging-button page-item ${page === currentPage ? "active" : ""}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    role="link"
                                                    type="button"
                                                    aria-controls="kt_customers_table"
                                                    aria-current={page === currentPage ? "page" : undefined}
                                                    onClick={() => handlePageClick(page)}
                                                    disabled={page === "..."}
                                                >
                                                    {page}
                                                </button>
                                            </li>
                                        ))}

                                        {/* Next Button */}
                                        <li
                                            className={`dt-paging-button page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                            <button
                                                className="page-link next"
                                                role="link"
                                                type="button"
                                                aria-controls="kt_customers_table"
                                                aria-disabled={currentPage === totalPages}
                                                aria-label="Next"
                                                onClick={handleNext}
                                            >
                                                <i className="next"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                    {currentRecords?.map(item => (
                        <div
                            key={`modal-${item.Id}`}
                            className="modal fade"
                            id={`imageModal-${item.Id}`}
                            tabIndex="-1"
                            aria-labelledby={`imageModalLabel-${item.Id}`}
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-dialog-centered modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id={`imageModalLabel-${item.Id}`}>
                                            Image Preview
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body text-center">
                                        <img
                                            src={`${BASE_IMAGE_API_URL}${item.ImageUrl1}`}
                                            alt="Enlarged"
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '70vh',
                                                borderRadius: '10px',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <ViewProduct viewObj={viewItem}/>
                <AddProduct />
                <EditProduct editObj={editItem} />
            </div> 
        </MainLayout>
    )
}